module.exports = __webpack_public_path__ + "img/purple-3-diamond-striped.4050d681.svg";